import React from "react";
import styled from "styled-components";
import { Circle } from "react-shapes";
import omit from "lodash.omit";

type Props = {
  r?: number,
  fillColor?: string,
  strokeColor?: string,
  strokeWidth?: number,
  opacity?: number
};

const propsToOmit = ["r", "fill", "stroke", "strokeWidth"];

const SvgCircle = (props: Props) => (
  <Wrap {...omit(props, propsToOmit)}>
    <Circle
      r={props.r}
      fill={{ color: props.fillColor }}
      stroke={{ color: props.strokeColor }}
      strokeWidth={props.strokeWidth}
    />
  </Wrap>
);

SvgCircle.defaultProps = {
  r: 4,
  fillColor: "none",
  strokeColor: "#0084FF",
  strokeWidth: 1,
  opacity: 0.2
};

export default SvgCircle;

// Styled Components
const Wrap = styled.div`
  opacity: ${p => p.opacity};
`;



// WEBPACK FOOTER //
// ./src/components/ui/Circle.jsx